import { createSelector } from '@ngrx/store';
import { AppState } from '../../core/store/core.state';

export const subscriptionState = (state: AppState) => state.subscription;

export const getSubscriptionsSelector = createSelector(
    subscriptionState,
    (state) => state.subscriptionList
);

export const getCurrentSubscriptionSelector = createSelector(
    subscriptionState,
    (state) => state.currentSubscription
);
